<template>
    <v-toolbar fixed app clipped-left :color="$utils.isMobile() ? '#01A6BE' : '#01AFC8'">
        <div class="icon-container" :class="{'pl-3': $utils.isNotMobile()}">
            <v-btn @click="toggleNavigation" fab flat class="t-btn">
                <v-icon color="white">menu</v-icon>
            </v-btn>
            <div style="height: calc(100% - 10px);max-height: 44px;">
                <Logo style="height: 100%" @click="redirectTo('/getting-started')" color="#fff"></Logo>
                <span class="logo-text" v-if="$utils.isNotMobile()">Platform</span>
            </div>
        </div>
        <SelectProject></SelectProject>
        <v-spacer></v-spacer>
        <LanguageSelector></LanguageSelector>
        <!--        <UserNotification></UserNotification>-->
        <UserMenu></UserMenu>
    </v-toolbar>
</template>
<script>
import SelectProject from './SelectProject.vue'
import LanguageSelector from '../modules/fptai/components/LanguageSelector.vue'
import UserMenu from '../modules/fptai/components/UserMenu.vue'
import Logo from '@/components/Logo'
// import UserNotification from './UserNotification'

export default {
    name: 'AppToolbar',
    components: { SelectProject, LanguageSelector, UserMenu, Logo },
    created () {
        if (this.$store.getters.token) {
            this.$store.dispatch(this.$actionTypes.user.GET_PROFILE)
        }
    },
    methods: {
        redirectTo (url) {
            this.$router.push(url)
        },
        toggleNavigation () {
            this.$store.dispatch(this.$actionTypes.TOGGLE_NAVIGATION)
        }
    }
}
</script>
<style scoped>
    .icon-container {
        background-color: #01A6BE;
        display: flex;
        align-items: center;
        height: 100%;
        width: 300px;
    }

    .t-btn {
        height: 30px;
        width: 30px;
        /*margin-top: 25px;*/
    }

    .logo-text {
        font-weight: bold;
        font-size: 16px;
        color: #fff;
    }

    /deep/ .v-toolbar__content {
        padding: 0;
    }
</style>
